import React from 'react';
import '../../src/bootstrap.css';
import { benefits } from './Data';


const Card = (cardInfo ) => {
 const {id,price, pricebackground, planType, buttonType, buttonText} = cardInfo;
  const versionOne = benefits[id];
  const { packaging} = versionOne;
  
  
  
  
  
  

 return ( 
  <>
   <div className="card my-4 mx-auto d-block" key={id}>
   <div className={pricebackground} >
   {price}
   </div>
   <p className="text-center work-text text-dark mt-5">{planType}</p>
     <div className="card-body text-center">

        {packaging.map((item) => {
          return (
            <p className="offer-item"> {item} </p> 
          )
        })}
       <button className= {buttonType}>
       {buttonText}
       </button>
     </div>

   </div>
   {/* <HeroSection /> */}
   {/* <Cards /> */}
   {/* <Footer /> */}
  </>
 )
}

export default Card